import type { HapticEvery } from '../types';

export function vibrateForRep(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [8]);
  } catch {
    return false;
  }
}

export function vibrateForMilestone(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [96, 28, 72, 20, 48]);
  } catch {
    return false;
  }
}

export function vibrateForVictory(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [180, 40, 120, 35, 180, 55, 260]);
  } catch {
    return false;
  }
}

export function maybeVibrateForJump(jumpCount: number, every: HapticEvery, nav: Navigator = navigator): boolean {
  return vibrateForRep(every !== 0 && jumpCount > 0, nav);
}

export function vibrateForTap(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [18, 16, 18]);
  } catch {
    return false;
  }
}

export function vibrateForCounterCountdown(step: 3 | 2, enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, step === 3 ? [220, 45, 260, 45, 300] : [320, 35, 380, 35, 460]);
  } catch {
    return false;
  }
}

export function vibrateForDodgeWarning(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [520, 55, 520, 55, 700]);
  } catch {
    return false;
  }
}

export function vibrateForDodgeSuccess(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [70, 35, 170]);
  } catch {
    return false;
  }
}

export function vibrateForDodgeFailure(enabled: boolean, nav: Navigator = navigator): boolean {
  if (!enabled) return false;
  const vibrate = nav.vibrate;
  if (typeof vibrate !== 'function') return false;
  try {
    return vibrate.call(nav, [280, 60, 120]);
  } catch {
    return false;
  }
}
